<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-YangTai`]" width="1em" height="1em" v-bind="$attrs"><path d="M18.375 4.125H4.875V18.375H18.375V4.125Z" stroke="#333"/><path d="M.75 12.0002V3.41493C.75 2.86947 1.31377 2.50644 1.81035 2.73216L4.875 4.12518V11.2502M.75 12.0002V19.0506C.75 19.593 1.30799 19.956 1.80388 19.7363L4.875 18.3752V11.2502M.75 12.0002L4.875 11.2502M22.5 12.0002V3.41493C22.5 2.86947 21.9362 2.50644 21.4397 2.73216L18.375 4.12518V11.2502M22.5 12.0002V19.0506C22.5 19.593 21.942 19.956 21.4461 19.7363L18.375 18.3752V11.2502M22.5 12.0002L18.375 11.2502" stroke="#333" stroke-linecap="round"/></svg>
</template>
<script>

export default {
  name: 'IconYangTai',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
